import { defineStore } from 'pinia';
import { api } from '@/utils/api';
import Cookies from 'js-cookie';
import router from '@/router';

export const useUserStore = defineStore('user', {
    state: () => ({
        myUserInfo: null,
        users: null,
    }),
    actions: {
        async fetchMyUserInfo() {
            try {
                const res = await api.get('/auth/api/accounts/user/me');
                // const roles = await api.get(`/auth/api/accounts/user/${res.data.id}/roles`);

                // const userList = res.data;
                // const myUser = userList.find(user => user.username === username);

                this.myUserInfo = res.data;
                // this.myUserInfo.roles = roles.data;
                console.log(this.myUserInfo);
                // return myUser
            } catch (e) {
                console.error(e);
            }
        },

        async fetchUsers() {
            try {
                const res = await api.get('/auth/api/accounts/user/list');
                this.users = res.data;
                console.log(this.users);
            } catch (e) {
                console.error(e);
            }
        },

        async addUser(user) {
            try {
                console.log(user);
                const res = await api.post('/auth/api/accounts/user/create_user', user);
                // this.users.push(res.data);
                console.log(res.data);
                return null;
            } catch (e) {
                console.error(e);
                return e;
            }
        },

        async editUser(userId, userData) {
            try {

                console.log(userData);
                const roleData = { user_id: userId, role_ids: userData.roles };
                console.log(roleData);
                const newUserData = {
                    username: userData.username,
                    phone_number: userData.phone_number,
                }
                delete userData.roles;
                const res = await api.patch(`/auth/api/accounts/user/${userId}/update`, newUserData);
                const res2 = await api.post(`/auth/api/accounts/user/assign_roles`, roleData);
                const index = this.users.findIndex(u => u.id === userId);
                console.log(res);
                console.log(res2);
                if (index !== -1) {
                    this.users[index] = res.data;
                }
                return null;
            } catch (e) {
                console.error(e);
                return e;
            }
        },
        async deleteUser(userId) {
            try {
                await api.delete(`/auth/api/accounts/user/${userId}/delete`);
                this.users = this.users.filter(u => u.id !== userId);
                return null;
            } catch (e) {
                console.error(e);
                return e;
            }
        },

        logout() {
            this.myUserInfo = null;
            router.push('/login');
            Cookies.remove('access_token');
            localStorage.removeItem('active_tab');
            localStorage.removeItem('isNavBarVisible');
            localStorage.removeItem('isHeaderVisible');
            localStorage.removeItem('isAiChatVisible');
        }
    }
});
